<script>
import Layout from "../../layouts/main";
import axios from "axios";
import CampaignForm from "@/components/campaignForm";
import {FormWizard, TabContent} from "vue-form-wizard";
import CampaignAttachments from "@/components/campaignAttachments";
import Vue from "vue";


/**
 * Form Layouts component
 */
export default {
  page: {
    title: "Create campaign",
  },
  components: {CampaignAttachments, CampaignForm, Layout, FormWizard, TabContent},
  methods: {
    async saveCampaign(campaign) {
      try {
        this.$store.commit('errorBag/CLEAR');

        const formData = new FormData();
        for (let key in campaign) {
          if (!campaign[key]) {
            formData.append(key, '');
          } else {
            formData.append(key, campaign[key]);
          }
        }
        this.$store.commit('loader/START_LOADING');

        const response = await axios.post('/client/campaign', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });

        this.newlyCreatedCampaign = response.data;

        Vue.set(this.newlyCreatedCampaign, 'links', [])
        Vue.set(this.newlyCreatedCampaign, 'attachments', [])

        this.$store.commit('campaign/ADD_CAMPAIGN', this.newlyCreatedCampaign);

        this.$refs.formWizard.nextTab();

      } catch (error) {
        // eslint-disable-next-line no-empty
      } finally {
        this.$store.commit('loader/END_LOADING');
      }
    },
    complete() {
      this.$router.push('/client/campaigns');
    }
  },
  computed: {
  },
  data() {
    return {
      newlyCreatedCampaign: null,
    };
  },
};
</script>

<template>
  <Layout>
    <div class="row pt-3">
      <div class="offset-lg-1 col-lg-10" >

        <div class="card">
          <div class="card-body">
            <h2 class="card-title text-center mb-4 font-size-20">Create Campaign</h2>

            <form-wizard ref="formWizard" color="#01baf1">

              <tab-content title="Create Campaign" >

                <campaign-form @campaignFormSubmitted="saveCampaign"></campaign-form>

              </tab-content>
              <tab-content title="Upload attachments" >
                <campaign-attachments v-if="newlyCreatedCampaign" :campaign="newlyCreatedCampaign"></campaign-attachments>
              </tab-content>

              <template slot="footer" slot-scope="props">
                <div class="wizard-footer-right">
                  <button v-if="props.isLastStep" @click="complete" class="btn btn-primary px-4 wizard-footer-right">Finish</button>
                </div>
              </template>
            </form-wizard>


          </div>
        </div>
      </div>
    </div>


  </Layout>
</template>
